import generatorRow from '@/components/generator/row'
import button from '@/components/rules/actions/generators/buttons/button'

function renderItem(h, item, index) {
  return h(
    button,
    {
      props: {
        value: item
      },
      on: {
        input: event => {
          this.$set(this.proxy, index, event)
        }
      }
    }
  )
}

export default function(h) {
  return h(
    generatorRow,
    {
      props: {
        value: this.proxy,
        defaultValue: this.defaultButton
      },
      scopedSlots: {
        row: ({ item, index }) => {
          return renderItem.call(this, h, item, index)
        }
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
